import api from "./api";

const activesService = {
    get: (jwttoken) =>
        api.get(`/actives`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getByCategory: (jwttoken, category) =>
        api.get(`/getActives/${category}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getActivesWhereUserHasBalance: (jwttoken) =>
        api.get(`/actives/getActivesWhereUserHasBalance/list`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getById: (jwttoken, activeId) =>
        api.get(`/actives/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }), 
    getLastQuotesByActiveId: (jwttoken, activeId) =>
        api.get(`/actives/getLastQuotesByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default activesService;